<ng-container>
  <nav class="side-navbar">
    <div class="side-navbar-wrapper">
      <div class="sidenav-header d-flex align-items-center justify-content-center">
        <div class="sidenav-header-inner text-center">
          <!-- <img *ngIf="isLogo" [src]="profile?.profile_pic_name" onerror="this.src='assets/images/Student/default_profile_photo_student.png'" alt="person" class="img-fluid rounded-circle" /> -->
          <img [src]="profile?.profile_pic_path" onerror="this.src='assets/images/Student/default_profile_photo_student.png'" alt="person" class="img-fluid rounded-circle" />

          <h2 class="welcome-user">Welcome, <span>{{profile?.first_name}}  {{profile?.last_name}}</span></h2>
        </div>
        <!-- <div class="sidenav-header-logo"><a href="/" class="brand-small text-center">
            <strong>S</strong><strong class="text-primary">C</strong></a>
        </div> -->
        <div class="sidenav-header-logo">
          <a 
            href="javascript:void(0)" 
            class="brand-small text-center"
            (click)="navigateToRoleBasedPage()"
          >
            <strong>S</strong><strong class="text-primary">C</strong>
          </a>
        </div>
        
      </div>
      <div class="main-menu">
        <ul id="side-main-menu" class="side-menu list-unstyled">
          <ng-container *ngFor="let item of sidebarModel.sidebarItems; let i = index;">
            <ng-container *ngIf="item.status !== null ? profile?.status === item.status : true">
              <li *ngIf="item.roleAccess.includes(profile?.role) && item.showLabel"
              [ngClass]="{'active': activeIndex === i, 'dropdown': item.isDropdown, 'disabled-menu-item': item.slug === 'ssphub' && !isAlumniProfileUpdated}">
                <ng-container *ngIf="!item.isDropdown; else dropdownTemplate">
                  <a (click)="navigateToModule(item.slug, item.operationType, i)" routerLinkActive="active"
                    [routerLink]="['/', item.slug]"  [ngClass]="{'disabled': item.slug === 'ssphub' && !isAlumniProfileUpdated}">
                    <i [class]="item.filePath" [ngClass]="{'active-icon': activeIndex === i}"></i>
                    {{ item.menuItem }}
                  </a>
                </ng-container>
                <ng-template #dropdownTemplate>
                  <a (click)="toggleDropdown(i, $event)" class="dropdown-toggle"
                    [class.open]="activeDropdownIndex === i">
                    <i [class]="item.filePath" [ngClass]="{'active-icon': activeIndex === i}"></i>
                    {{ item.menuItem }}
                  </a>
                  <ul class="collapse list-unstyled" [ngClass]="{'show': activeDropdownIndex === i}">
                    <li *ngFor="let subItem of item.dropdownItems; let j = index;"
                      [ngClass]="{'active': subItemActiveIndex[i] === j}">
                      <a (click)="navigateToModule(subItem.slug, subItem.operationType, i, true, j)" class="click-pointer">
                        <i [class]="subItem.filePath" [ngClass]="{'active-icon': subItemActiveIndex[i] === j}"></i>
                        {{ subItem.menuItem }}
                      </a>
                    </li>
                  </ul>
                </ng-template>
              </li>
            </ng-container>
          </ng-container>
   
          <li>
            <a class="cursorHand" (click)="logout()">
              <i class="logout-white-icon cursorHand"></i> Logout
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</ng-container>
